export const VALUE_IN = 'IN'
export const VALUE_OUT = 'OUT'
export const VALUE_RND = 'RND'
export const VALUE_PURCHASING = 'PURCHASING'
export const VALUE_FILLING = 'FILLING'
export const VALUE_GUDANG_SETENGAH_JADI = 'GUDANG_SETENGAH_JADI'
export const VALUE_GUDANG_JADI = 'GUDANG_JADI'
export const VALUE_GUDANG_RUAHAN = 'GUDANG_RUAHAN'
export const VALUE_GUDANG_MIXING = 'GUDANG_MIXING'
export const VALUE_GUDANG_LABEL = 'GUDANG_LABEL'
export const VALUE_RETURN_TO_SUPPLIER = 'RETURN_TO_SUPPLIER'
export const VALUE_EXPIRED = 'EXPIRED'
export const VALUE_FAIL_QC = 'FAIL_QC'
export const VALUE_RUKO_SCREEN_PRINTING = 'RUKO_SCREEN_PRINTING'
export const VALUE_ADJUSTMENT = 'ADJUSTMENT'
export const VALUE_GUDANG_BAHAN_BAKU = 'GUDANG_BAHAN_BAKU'
export const VALUE_GUDANG_PACKAGING = 'GUDANG_PACKAGING'
export const VALUE_QC = 'QC'
export const VALUE_SETENGAH_JADI = 'SETENGAH_JADI'
export const VALUE_BARANG_JADI = 'BARANG_JADI'
export const STOCK_CARD_TYPE_PACKAGING = 'TYPE_PACKAGING'
export const STOCK_CARD_TYPE_MIXING = 'TYPE_MIXING'
export const STOCK_CARD_TYPE_LABEL = 'TYPE_LABEL'
export const STOCK_CARD_TYPE_HALF_COMPLETE = 'TYPE_HALF_COMPLETE'
export const STOCK_CARD_TYPE_COMPLETE = 'TYPE_COMPLETE'
export const STOCK_CARD_TYPE_PREMIX = 'TYPE_PREMIX'
export const STOCK_CARD_TYPE_INGREDIENTS = 'TYPE_INGREDIENTS'
export const STOCK_CARD_TYPE_INGREDIENTS_OUT_BATCH =
  'TYPE_INGREDIENTS_OUT_BATCH'
export const STOCK_CARD_TYPE_INGREDIENTS_READ_ONLY =
  'TYPE_INGREDIENTS_READ_ONLY'
export const STOCK_CARD_TYPE_INGREDIENTS_OUT_SINGLE =
  'TYPE_INGREDIENTS_OUT_SINGLE'
